import { React, useEffect, useRef, useState } from "react";
import { Button, Skeleton, Tooltip } from "antd";
import { Styled } from "../../Pages/pageStyled";
import {
  lengthUnit,
  weightUnit,
} from "../../Utils/Constant/MeasurementUnitList";
import IcoMoon from "react-icomoon";
import Iconmoon from "../IconsFiles/icon";
import dragIcon from "../../Assets/Icons/drag-and-drop-icon.svg";
const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

const JobCardCylinderChildMultistage = ({
  classname,
  order,
  multiview,
  units,
  trimloss,
  totalWidth,
  maxWidth,
  handleDrag,
  handleDrop,
  uuid,
  openIntermediateReelSheets,
  isValidState = false,
  reRender,
  deckleMatchPage = false,
  index,
  cylinderViewData
}) => {
  const divRef = useRef(null);
  const factor = order.width / totalWidth;
  const diff = maxWidth - totalWidth;
  const [availableWidth, setAvailableWidth] = useState(0);
  const [isDispay, setIsDisplay] = useState(false);
  const cylinderText =
    order.item_type === "trim_loss"
      ? `${order.item_type === "trim_loss" ? trimloss : ""}`
      : `${order.reel_width}`;

  const cylinderTextWithUnits =
    order.item_type === "trim_loss"
      ? `
    ${order.item_type === "trim_loss" ? trimloss : ""} 
    ${
      units
        ? order.item_type === "trim_loss"
          ? lengthUnit[units.trim_loss]?.displayName
          : lengthUnit[units.reel_width]?.displayName
        : "cm"
    }
  `
      : `${order.reel_width} ${
          units
            ? order.item_type === "trim_loss"
              ? lengthUnit[units.trim_loss]?.displayName
              : lengthUnit[units.reel_width]?.displayName
            : "cm"
        } `;

  let titleContent = "";
  let draggableContent = "";

  switch (order.item_type) {
    case "trim_loss":
      titleContent = `Type: Trim Loss \nWeight: ${order.weight} ${
        units ? capitalize(weightUnit[units.weight]?.displayName) : "Tonnes"
      } \nTrim Loss: ${trimloss} ${
        units ? lengthUnit[units.trim_loss]?.displayName : "cm"
      }`;
      break;
    case "product_stock_size":
    case "stock":
      titleContent = `Stock No.: ${order.id} \n Size: ${
        order.order_type === "reel"
          ? `${order.order_width}`
          : order.order_type === "sheet"
          ? `${order.order_width} x ${order.order_length}`
          : ""
      } ${
        units ? lengthUnit[units.order_width]?.displayName : "cm"
      } \n Type: ${capitalize(order.order_type)} \nWeight: ${
        order.weight ? order.weight.toFixed(3) : ""
      } ${
        units ? capitalize(weightUnit[units.weight]?.displayName) : "Tonnes"
      } \nPriority: ${order.priority ? "Yes" : "No"}`;
      break;
    default:
      if (order.reel_type === "intermediate_reel") {
        titleContent = `Size: ${order.reel_width}  ${
          units ? lengthUnit[units.order_width]?.displayName : "cm"
        }\nType: Intermediate Reel\nCutting Pattern:  (${order.intermediate_reels_data
          .map((item) => item.size)
          .join(" + ")}) x ${order.length} ${
          units ? lengthUnit[units.order_width]?.displayName : "cm"
        }\nLeft Edge Trim: ${order.left_edge_trim} ${
          units?.left_edge_trim
            ? lengthUnit[units?.left_edge_trim].displayName
            : "cm"
        }\nRight Edge Trim: ${order.right_edge_trim} ${
          units?.left_edge_trim
            ? lengthUnit[units?.left_edge_trim].displayName
            : "cm"
        }\nTrim Loss: ${order.trim_loss} ${
          units
            ? order.item_type === "trim_loss"
              ? lengthUnit[units.trim_loss]?.displayName
              : lengthUnit[units.order_width]?.displayName
            : "cm"
        }\nWeight: ${order.weight} ${
          units?.weight
            ? capitalize(weightUnit[units?.weight].displayName)
            : "T"
        }\nPriority: ${
          order.priority ? "Yes" : "No"
        }\n\nClick on this reel to view the cutting pattern`;
      } else {
        titleContent = `Order No.: ${order.order} \n Size: ${
          order.order_type === "reel"
            ? `${order.order_width}`
            : order.order_type === "sheet"
            ? `${order.order_width} x ${order.order_length}`
            : ""
        } ${
          units ? lengthUnit[units.order_width]?.displayName : "cm"
        } \n Type: ${capitalize(order.order_type)} \nWeight: ${
          order.weight ? order.weight.toFixed(3) : ""
        }  ${
          units ? capitalize(weightUnit[units.weight]?.displayName) : "Tonnes"
        } \nPriority: ${order.priority ? "Yes" : "No"}`;
      }
      break;
  }

  draggableContent = isValidState ? "Draggable: Yes" : "";

  const finalTitleContent = `${titleContent}\n${draggableContent}`;

  const handleCheckAvailableWidth = () => {
    const spanElement = document.getElementById(
      JSON.stringify({
        uuid: uuid,
        combinationNumber: order.combinationNumber,
      })
    );
    if (spanElement && spanElement.offsetWidth > 0) {
      setAvailableWidth(spanElement.offsetWidth);
    }
  };

  const handleClick = () => {
    if (order.reel_type !== "intermediate_reel") return;
    openIntermediateReelSheets &&
      openIntermediateReelSheets(
        order,
        !isDispay,
        `calc(${factor * 100}% - 23px)`,
        index,
        availableWidth
      );
    setIsDisplay(!isDispay);
  };
  useEffect(() => {
    handleCheckAvailableWidth();
  });
  useEffect(() => {
    const checkAvailableWidth = () => {
      const spanElement = document.getElementById(
        JSON.stringify({
          uuid: uuid,
          combinationNumber: order.combinationNumber,
        })
      );
      if (spanElement && spanElement.offsetWidth > 0) {
        setAvailableWidth(spanElement.offsetWidth);
      }
    };

    // Ensure the DOM is ready before attempting to measure
    if (divRef.current) {
      checkAvailableWidth();
    }
  }, [reRender, uuid, order.combinationNumber]);

  return (
    <div
      class={classname}
      style={{
        width: `calc(${factor * 100}% )`,
        left: order.left,
        // border: isValidState && '2px solid #a2a2a2',
        // boxSizing: "border-box",
        boxShadow: isValidState && "0 3px 12px rgb(0 0 0 / 0.2)",
        // backgroundColor: order.reel_type === "intermediate_reel" ? "#EA655B" : "",
      }}
    >
      {/* {isLoading ? (
        <Skeleton.Button
          active={true}
          style={{ width: "90%" }}
          size={"large"}
          shape={"default"}
          block={true}
          className="shimmer"
        />
      ) : ( */}
      <Tooltip overlayClassName="cylinderToottip" title={finalTitleContent}>
        <span
          style={{
            padding: "34px 20px 6px 10px",
            display: "inline-flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "85%",
            height: "100%",
            textAlign: "center",
            // marginRight: '5px'
            cursor: order.reel_type === "intermediate_reel" ? "pointer" : "",
          }}
          className={`cylinder-text${uuid}`}
          draggable={isValidState}
          onDragOver={(ev) => ev.preventDefault()}
          onDragStart={handleDrag}
          onDrop={handleDrop}
          id={JSON.stringify({
            uuid: uuid,
            combinationNumber: order.combinationNumber,
          })}
          onClick={cylinderViewData==='order' && handleClick}
          ref={divRef}
          onResize={handleCheckAvailableWidth}
        >
          {(availableWidth >= 25 || deckleMatchPage) &&
            order.reel_type === "intermediate_reel" && !isValidState && (
              <Iconmoon
                style={{
                  position: "absolute",
                  top: "26%",
                  // alignSelf: "center",
                  width: "15px",
                  opacity: "0.7",
                  // left: "50%",
                  // transform: "translate(-100%, -50%)",
                }}
                icon="sheet"
                size={20}
                // color="#fefefe"
              />
            )}
          {availableWidth >= 40 || deckleMatchPage ? (
            <>
              {isValidState && availableWidth >= 40 && (
                // <div style={{ width: "100%" }}>
                <svg
                  style={{
                    position: "absolute",
                    top: "35%",
                    // alignSelf: "center",
                    width: "15px",
                    opacity: "0.7",
                    // left: "50%",
                    // transform: "translate(-100%, -50%)",
                  }}
                  viewBox="64 64 896 896"
                  focusable="false"
                  data-icon="holder"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"></path>
                </svg>
                // </div>
              )}

              {/* <div style={{position: 'absolute', left: '30%'}}> */}
              {availableWidth >= 50 || order.width > 50 ? (
                <span
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                    width: "85%",
                  }}
                >
                  {cylinderTextWithUnits}
                </span>
              ) : (
                //   availableWidth >= cylinderText.length * 6 ? (
                //   <span
                //     style={{
                //       overflow: "hidden",
                //       textOverflow: "ellipsis",
                //       whiteSpace: "nowrap",
                // display: "block",
                // width: "85%",
                //     }}
                //   >
                //     {cylinderText}
                //   </span>
                // ) : (
                <> </>
              )}
              {/* </div>  */}
            </>
          ) : (
            <></>
          )}
        </span>
      </Tooltip>
    </div>
  );
};

export default JobCardCylinderChildMultistage;
